<template>
  <div class="crumb-container">
    <b-breadcrumb>
      <b-breadcrumb-item
        :to="c.to"
        v-for="(c, index) in crumbs"
        :key="c.to + index"
        :active="isLastItem(index)"
      >
        <div
          v-if="c.isTemplate && !c.noPrefixIcon"
          class="slds-icon_container slds-icon-standard-template"
        >
          <svg class="crumb-icon slds-icon">
            <use
              xlink:href="@/assets/icons/standard-sprite/svg/symbols.svg#template"
            ></use>
          </svg>
        </div>
        <div
          class="slds-icon_container slds-icon-standard-dashboard-ea"
          v-if="hasContentIcon(c) && !c.noPrefixIcon"
        >
          <svg class="crumb-icon slds-icon" v-if="!isCustomContent(c)">
            <use
              xlink:href="@/assets/icons/standard-sprite/svg/symbols.svg#dashboard_ea"
            ></use>
          </svg>
          <svg class="crumb-icon slds-icon slds-icon-custom-67" v-else>
            <use xlink:href="@/assets/icons/SLDS-icons.svg#custom67"></use>
          </svg>
        </div>

        {{ c.text }}
      </b-breadcrumb-item>
    </b-breadcrumb>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import { PAGES_PATH } from "@/static/global-variables";

  export default {
    computed: {
      ...mapState([
        "apps",
        "messages",
        "distributionChannelDetail",
        "distributionChannelLatestWidgets",
        "widgetVersions"
      ]),
      crumbs: function() {
        const currentPath = this.$route.path;
        let pathArray = currentPath.split("/");
        pathArray.shift();
        let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
          if (idx < pathArray.length) {
            let text = "";
            let to = "";

            if (idx === 0) {
              // Add Home breadcrum
              text = this.$route.matched[idx].meta.breadCrumb;
              let messageObj = this.messages[text];
              if (messageObj && messageObj.Text_vod__c) {
                text = messageObj.Text_vod__c;
              }
              path = PAGES_PATH.APPS;
              to = `/${PAGES_PATH.APPS}`;
            } else {
              /*
                idx indicates which index in pathArray is looping
                path indicates the value on the array in index: idx
                Get path up to current path value
                split currentPath and keep up to (idx + 3)
                For example - currentPath: /distribution-channels/XYZ-UUID/custom-display-elements/123-UUID/details/3.0.0
                idx = 1
                path = XYZ-UUID
                subPath = ['', 'distribution-channels', 'XYZ-UUID', 'custom-display-elements']
                to = /distribution-channels/XYZ-UUID/custom-display-elements
                to will be the correct path when the user clicks on the breadcrum in that link
                NOTE: in the case of XYZ-UUID the text will be replaced the name of the Distribution Channel
                as well as other UUIDs will be replaced by the objects name value
              */
              let subPath = currentPath.split("/", idx + 3);
              to = subPath.join("/");

              if (pathArray[0] === PAGES_PATH.DISTRIBUTION_CHANNELS) {
                let output = breadcrumbArray.find(bc => {
                  return bc && bc.path === PAGES_PATH.DISTRIBUTION_CHANNELS;
                });
                if (!output) {
                  breadcrumbArray.push({
                    path: PAGES_PATH.DISTRIBUTION_CHANNELS,
                    to: `/${PAGES_PATH.DISTRIBUTION_CHANNELS}`,
                    text: this.$t("distributionChannels"),
                    noPrefixIcon: true
                  });
                }

                text =
                  this.distributionChannelDetail &&
                  path === this.distributionChannelDetail.uuid
                    ? this.distributionChannelDetail.name
                    : "";

                if (!text && this.distributionChannelLatestWidgets) {
                  const widget = this.distributionChannelLatestWidgets.widgets.find(
                    w =>
                      w.uuid === path ||
                      (w.current && w.current.uuid === path) ||
                      (w.unpublished && w.unpublished.uuid === path)
                  );
                  if (widget) {
                    if (widget.uuid === path) {
                      text = widget.name;
                    } else {
                      text =
                        widget.current && widget.current.uuid === path
                          ? widget.current.version
                          : widget.unpublished.version;
                    }
                  }
                }
                if (!text && this.widgetVersions) {
                  const widget = this.widgetVersions.versions.find(
                    w => w.uuid === path
                  );
                  text = widget ? widget.version : "";
                }
              } else {
                const currentApp = this.apps.find(app => {
                  return app.uuid === path;
                });
                if (currentApp) {
                  text = currentApp.name;

                  if (!currentApp.isTemplate) {
                    breadcrumbArray.push({
                      path: PAGES_PATH.APPS,
                      to: "/apps",
                      text: this.$t("page"),
                      noPrefixIcon: true,
                      isTemplate: currentApp.isTemplate,
                      isCustomContent: currentApp.isCustomContent
                    });
                  } else {
                    breadcrumbArray.push({
                      path: PAGES_PATH.APPS,
                      to: "/templates",
                      text: this.$t("pageTemplates"),
                      noPrefixIcon: true,
                      isTemplate: currentApp.isTemplate,
                      isCustomContent: currentApp.isCustomContent
                    });
                  }
                }
              }
            }

            let isTemplate;
            let isCustomContent;
            let currentApp = this.apps.find(app => {
              return app.uuid === path;
            });
            if (currentApp) {
              text = currentApp.name;
              isTemplate = currentApp.isTemplate;
              isCustomContent = currentApp.customContent;
            }

            if (text) {
              breadcrumbArray.push({
                path: path,
                to: to,
                text: decodeURI(text),
                isTemplate: isTemplate,
                isCustomContent: isCustomContent
              });
            }
          }
          return breadcrumbArray;
        }, []);

        if (breadcrumbs.length === 1) {
          // append empty to enable Home page link
          breadcrumbs.push({ path: "", to: "", text: "" });
        }
        return breadcrumbs;
      }
    },
    methods: {
      hasContentIcon(crumb) {
        return crumb.isTemplate === false;
      },
      isCustomContent(crumb) {
        return crumb.isCustomContent;
      },
      isLastItem(index) {
        return index === this.crumbs.length - 1;
      }
    }
  };
</script>
<style scoped>
  .crumb-container {
    background-color: rgb(255, 255, 255);
  }

  .crumb-icon {
    width: 1rem;
    height: 1rem;
  }
</style>
